import type { TFunction } from 'i18next';
import { z } from 'zod';

export const NameSectionSchema = (t?: TFunction) => {
	const requiredMsg = t
		? t('This field is required')
		: 'This field is required';

	return z.object({
		hcoNameCda_V: z
			.string({ error: requiredMsg })
			.trim()
			.min(1, { message: requiredMsg })
	});
};

export type NameSectionValuesIn = z.input<ReturnType<typeof NameSectionSchema>>;
export type NameSectionValuesOut = z.output<
	ReturnType<typeof NameSectionSchema>
>;
